/* eslint-disable */
import request from './helpers'

export function listGroup (username) {
    return request ({
        url: '/api/v1/user/' + username + '/groups',
        method: 'get'
    })
}

export function listTopicsByGroup (username, group) {
    return request ({
        url: '/api/v1/user/' + username + '/' + group + '/search/topics',
        method: 'get'
    })
}

export function addGroup (data) {
    return request ({
        url: '/api/v1/user/add/group',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function updateGroup (id, data) {
    return request ({
        url: '/api/v1/user/' + id + '/edit/group',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteGroup (id) {
    return request ({
        url: '/api/v1/user/' + id + '/remove/group',
        method: 'delete'
    })
}

export function bindGroup (data) {
    return request ({
        url: '/api/v1/user/bind',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function unbindGroup (data) {
    return request ({
        url: '/api/v1/user/unbind',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}
